import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import config from "@/config/index";
const state = config.Widget;

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
};